import type {PersistedSidebarState} from './types';

// When resizing, allow the sidebar to "snap" to it's default width when falling within +/- this value
export const SIDEBAR_RESIZE_SNAP_WINDOW = 12;
export const SIDEBAR_MIN_WIDTH = 200;
export const SIDEBAR_DEFAULT_WIDTH = 320;
export const SIDEBAR_COLLAPSED_WIDTH = 60;
export const SIDEBAR_MAX_WIDTH = 560;

export const DEFAULT_PERSISTED_STATE: PersistedSidebarState = {
  isCollapsed: false,
  width: SIDEBAR_DEFAULT_WIDTH,
};

export const TOGGLE_COLLAPSE_EVENT = `toggleCollapse`;

export enum TrackingEvent {
  ExpandedSidebar = `Expanded Sidebar`,
  CollapsedSidebar = `Collapsed Sidebar`,
  Resize = `Resize`,
  Reorder = `Reorder`,
}
